
import { Component } from "react";
import { makeBEM } from "../global/utils";
import { apiResultSuccess, getBoardSettings, getBoardTypes } from '../apihelper';
import Icon from '../atoms/Icon';
import EditButtonIcon from '../atoms/EditButtonIcon';
import { BoardSetting } from "./BoardSetting";
import { SortableBoardSettings } from "./SortableBoardSettings";
import { LABELS } from "../global/constants";
import { FormReveal } from "./Animations";
import BoardForm from '../forms/BoardForm';

class BoardsSettings extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: this.props.data ? this.props.data : false,
            contents: this.props.contents ? this.props.contents : false,
            controller: this.props.controller ? this.props.controller : false,
            editMode: false,            
            newMode: false,
            switchViewAction: this.props.switchViewAction ? this.props.switchViewAction : false
        }

        this.moduleName = 'boards-setting setting';
        this.bindFunctions();
    }

    bindFunctions() {
        this.toggleEditMode = this.toggleEditMode.bind(this);
        this.toggleNewMode = this.toggleNewMode.bind(this);
        this.newSuccess = this.newSuccess.bind(this);
    }

    setBoardsData(boards) {
        this.setState({
            contents: boards,
        });
    }

    getBoardsData() {
        getBoardSettings(
            (results) => {
                if ( apiResultSuccess(results) ) {
                    if ( results.boards ) {
                        this.setBoardsData(results.boards);
                    }
                }
            }
        )
    }

    setBoardTypesData(boardTypes) {
        this.setState({
            boardTypes: boardTypes
        });
    }

    getBoardTypesData() {
        getBoardTypes(
            (results) => {
                if ( apiResultSuccess(results) ) {
                    if ( results.types ) {
                        this.setBoardTypesData(results.types);
                    }
                }
            }
        )
    }

    componentDidMount() {
        // getthis data from datamanager or parent
        // this.getBoardsData();
        // this.getBoardTypesData();
    }

    toggleEditMode() {
        const newMode = this.state.newMode;
        if ( newMode ) {
            return false;
        }
        this.setState({
            editMode: !this.state.editMode
        })
    }

    toggleNewMode() {
        const newMode = this.state.newMode;
        this.setState({
            newMode: !newMode
        });
    }

    addNewBoard(board) {
        const newContents = this.state.contents;
        board.animate = true;
        newContents.push(board);

        this.setState({
            contents: newContents,
        });
    }

    newSuccess(results) {
        if ( results.board ) {
            const ctrl = this.state.controller;
            this.addNewBoard(results.board);
            
            ctrl.newBoardSuccess(results.board);

            this.setState({
                controller: ctrl
            });
        }
	}

    render() {
        const data = this.state.data;
        const contents = this.state.contents;
        const controller = this.state.controller;
        const newMode = this.state.newMode;
        const editMode = this.state.editMode;
        const boardTypes = controller.boardTypes;
        const editBtnIcon = !editMode ? 'edit' : 'check';
        
        const showNewBtn = true;
        const switchViewAction = this.state.switchViewAction;

        const switchViewBtnClass = `btn btn--icon btn--no-border btn--setting ${makeBEM('setting', 'switch-view-btn')} ${makeBEM(this.moduleName, 'switch-view-btn')}`;

        return (
            <div className={ this.moduleName }>
                <div className="setting__title-and-edit">
                    { 
						switchViewAction &&
						<button className={switchViewBtnClass} onClick={switchViewAction}>
							<Icon name="chevron-left" />
						</button>
					}
                    <h3 className="h3 setting__title">{data.title}</h3>
                    <button
                        className="btn btn--icon btn--no-border btn--setting setting__btn "
                        onClick={this.toggleEditMode}
                    >
                        <EditButtonIcon editMode={editMode} />
                    </button>
                </div>
                <div className="setting__column-names">
                    <span className="label">Title</span>
                    <span className="label">
                        { !editMode ? 'Show' : 'Order' }
                    </span>
                </div>

                <ul className={ makeBEM('settings', 'list') }>
                    <SortableBoardSettings 
                        data={Object.values(contents)} 
                        editMode={editMode} 
                        boardTypes={boardTypes}
                        controller={controller}
                    />
                </ul>


                {
                    showNewBtn &&
                    <div className="module__btn-wrapper board__form-btn">
                        <button 
                            className="btn btn--icon btn--icon-and-text" 
                            onClick={this.toggleNewMode}
                            disabled={editMode}
                        >
                            <Icon name="plus"/>
                            { LABELS.newBoard }
                        </button>
                    </div>
                }

                {
                    newMode &&
                    <FormReveal>
                        <BoardForm 
                            boardTypes={boardTypes}
                            newSuccess={this.newSuccess}
                            discardForm={this.toggleNewMode}
                        />
                    </FormReveal>
                }
            </div>
        );
    }
}

export default BoardsSettings;